import {
  ColorPickerComponent,
  type ColorPickerComponentProps,
  type ColorResult
} from "@common/controls/Inputs/ColorPicker/component";
import { IconType } from "@common/declarations";
import withDropdownHOC, { type WithDropdownCmpProps, type WithDropdownToggleProps } from "@common/hocs/withDropdown";
import React from "react";
import { useSlate } from "slate-react";
import { type MenuButtonPropsBase } from "../types";
import MenuButtonBase from "./Base";

type ColorPickerProps = ColorPickerComponentProps & {
  dropdownClassName?: string;
  isActive: boolean;
  isOpen: boolean;
  close: () => void;
};
const ColorPicker = React.forwardRef(
  (
    {
      dropdownClassName,
      isActive,
      isOpen,
      close,
      toggleOpen,
      open,
      maxHeight,
      ...props
    }: ColorPickerProps & WithDropdownCmpProps,
    ref: React.RefObject<any>
  ) => {
    return (
      <div ref={ref} className={"no-close-click-outside rich_editor_colorpicker no_select"}>
        <ColorPickerComponent {...props} />
      </div>
    );
  }
);

type ToggleProps = MenuButtonPropsBase & {
  isActive: boolean;
};
const Toggle = (props: ToggleProps & WithDropdownToggleProps) => (
  <MenuButtonBase
    ref={props.toggleRef}
    icon={IconType.Palette}
    isActive={props.isActive}
    isDisabled={props.isDisabled}
    onMouseDown={props.toggleOpen}
  />
);

const ForeColorButtonBase = withDropdownHOC<ToggleProps & ColorPickerComponentProps>(Toggle, ColorPicker);

type Props = MenuButtonPropsBase & {};
const ForeColorButton = (props: Props) => {
  const editor = useSlate();

  const [color, setColor] = React.useState<string | undefined>(editor.getMarks()?.color);

  const onChange = React.useCallback((color: ColorResult) => {
    setColor(color.hex);
  }, []);

  const onClose = React.useCallback(() => {
    editor.addMark("color", color);
  }, [color]);

  return <ForeColorButtonBase {...props} onChange={onChange} color={color} isActive={!!color} onClose={onClose} />;
};
export default ForeColorButton;
